import { useSearchParams } from "react-router-dom";

import { useGetOutputPointcloud } from "api/output/queries/useGetOutputPointcloud";

import { PtcldScriptContextProvider } from "contexts/PtcldScriptContext";
import { useGetScanQuery } from "api/scan/queries/useGetScanQuery";
import FullScreenInit from "components/FullScreenInit";
import PointCloudViewerContent from "./components/PointCloudViewerContent";

const ComparePointClouds = () => {

  // if (
  //     firstDataLoading || 
  //     secondDataLoading || 
  //     firstDataError || 
  //     secondDataError) {
  //       return (
  //         <FullScreenInit
  //           loading={firstDataLoading || secondDataLoading}
  //           displayText={firstDataError?.message || secondDataError?.message}
  //           animation="error"
  //           hideBackButton
  //           height="100%"
  //         />
  //       );
  //     }

  return (
    <PtcldScriptContextProvider>
      <PointCloudViewerContent/>
    </PtcldScriptContextProvider>
  );
}

export default ComparePointClouds